customElements.get("quick-add-modal") ||
  customElements.define(
    "quick-add-modal",
    class extends ModalDialog {
      constructor() {
        super(),
          (this.modalContent = this.querySelector('[id^="QuickAddInfo-"]')),
          window.addEventListener("keyup", (e) => {
            "ESCAPE" === e.code.toUpperCase() && this.hide();
          });
      }
      hide(e = !1) {
        var t = document.querySelector("cart-drawer");
        t && t.setActiveElement(this.openedBy), (this.modalContent.innerHTML = ""), e && (this.openedBy = null), super.hide(), setTimeout(() => this.remove(), 500);
      }
      show(t) {
        t.setAttribute("aria-disabled", !0),
          t.classList.add("loading"),
          t.querySelector(".loading-overlay__spinner") && t.querySelector(".loading-overlay__spinner").classList.remove("hidden"),
          fetch(t.getAttribute("data-product-url"))
            .then((e) => e.text())
            .then((e) => {
              e = new DOMParser().parseFromString(e, "text/html");
              (this.productElement = e.querySelector('section[id^="MainProduct-"]')),
                this.preventDuplicatedIDs(),
                this.removeDOMElements(),
                this.setInnerHTML(this.modalContent, this.productElement.innerHTML, t),
                window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init(),
                window.ProductModel && window.ProductModel.loadShopifyXR(),
                this.updateImageSizes(),
                this.preventVariantURLSwitching(),
                this.enableSizeGuide(e),
                this.enableSizeChart(),
                super.show(t);
            })
            .finally(() => {
              t.removeAttribute("aria-disabled"), t.classList.remove("loading"), t.querySelector(".loading-overlay__spinner") && t.querySelector(".loading-overlay__spinner").classList.add("hidden"), sliderQuickAddInit(this);
              if (this.modalContent.querySelector('option[data-disabled-option]') && this.modalContent.querySelector('option[data-disabled-option]').hasAttribute("selected") ) {
                this.modalContent.querySelector('.product-form__submit span').innerHTML = this.modalContent.querySelector('option[data-disabled-option]').innerHTML;
                this.modalContent.querySelector('.product-form__submit').setAttribute('aria-disabled', 'false');
                this.modalContent.querySelector('.product-form__submit').setAttribute('disabled', 'disabled');
              }

              // Checks if mobile screen, then checks if CTA is above the fold. If not, resizes images to make sure CTA is above the fold.
              if (window.innerWidth < 576) {
                const quickViewWrapper = this.querySelector('.quick-add-modal__content-wrapper');
                let lastbottom, stable = 0;
                
                const id = setInterval(() => {
                  const bottom = quickViewWrapper.getBoundingClientRect().bottom;

                  // Checks for when the quickview slide has finished opening
                  if (bottom === lastbottom && stable !== 5) {
                    ++stable
                  } else if (bottom == lastbottom && stable === 5) {
                    // Slide finished opening, line below stops the loop
                    clearInterval(id);

                    // Checks if CTA button is below the fold
                    if (this.querySelector('.product-form__submit').getBoundingClientRect().bottom > window.innerHeight) {
                      const ctaBtn = this.querySelector('.product-form__submit');
                      const imageWrapper = this.querySelector('.js-media-list-mobile');
                      const images = this.querySelectorAll('.js-media-list-mobile img');

                      let currentVH = parseFloat(getComputedStyle(imageWrapper).height) / window.innerHeight * 100;

                      // Reduces the imageWrapper/images height until CTA is above the fold 
                      const adjustUntilVisible = setInterval(() => {
                        const btnBottom = ctaBtn.getBoundingClientRect().bottom;
                        const fold = window.innerHeight;

                        if (btnBottom <= fold - 11) {
                          // CTA is now above the fold (with tolerance)
                          clearInterval(adjustUntilVisible);
                        } else {
                          // Keeps adjusting the imageWrapper + images heights until the CTA is above the fold
                          const newVH = (currentVH -= 1) + 'vh';
                          imageWrapper.style.height = newVH
                          for (let i = 0; i < images.length; i++) {
                            const img = images[i];
                            img.style.height = newVH;
                          }
                        }
                      }, 5);
                    }
                  } else {
                    lastbottom = bottom;
                    stable = 0;
                  }
                }, 1);
              }
            });
      }
      setInnerHTML(e, t, r) {
        (e.innerHTML = t),
          e.querySelectorAll("script").forEach((e) => {
            const t = document.createElement("script");
            Array.from(e.attributes).forEach((e) => {
              t.setAttribute(e.name, e.value);
            }),
              t.appendChild(document.createTextNode(e.innerHTML)),
              e.parentNode.replaceChild(t, e);
          });
        (t = document.createElement("h2")), t.setAttribute("class", "quick-add-modal__title h3"), (t.innerText = theme.quickAddTitle), e.querySelector(".product").prepend(t), (t = document.createElement("a"));
        (t.innerHTML = `<span>${theme.quickviewMore}</span>`),
          t.setAttribute("href", r.getAttribute("data-product-url")),
          t.setAttribute("class", "product__full-details button button--simple_secondary justify-center"),
          e.querySelectorAll(".product__info-column") && e.querySelectorAll(".product__info-column").length,
          e.querySelector(".product-form").appendChild(t);
      }
      removeDOMElements() {
        var e = this.productElement.querySelectorAll(".product-popup"),
          e =
            (e &&
              e.forEach((e) => {
                e.remove();
              }),
            this.productElement.querySelectorAll(".about")),
          e =
            (e &&
              e.forEach((e) => {
                e.remove();
              }),
            this.productElement.querySelector(".share-buttons")),
          e = (e && e.remove(), this.productElement.querySelector(".product__sku")),
          e = (e && e.remove(), this.productElement.querySelector(".breadcrumb")),
          e = (e && e.remove(), this.productElement.querySelector(".product-tags")),
          e = (e && e.remove(), this.productElement.querySelector(".pickup-availability")),
          e = (e && e.remove(), this.productElement.querySelector(".pickup-availability__overlay")),
          e = (e && e.remove(), this.productElement.querySelector("product-modal")),
          e = (e && e.remove(), this.productElement.querySelector(".product__description")),
          e = (e && e.remove(), this.productElement.querySelector(".product__inventory")),
          e = (e && e.remove(), this.productElement.querySelector(".product__media-sublist-outer"));
        e && e.remove();
      }
      preventDuplicatedIDs() {
        const t = this.productElement.dataset.section;
        (this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(t, "quickadd-" + t)),
          this.productElement.querySelectorAll("variant-selects, variant-radios").forEach((e) => {
            e.dataset.originalSection = t;
          });
      }
      preventVariantURLSwitching() {
        this.modalContent.querySelector("variant-radios,variant-selects") && this.modalContent.querySelector("variant-radios,variant-selects").setAttribute("data-update-url", "false");
      }
      updateImageSizes() {
        var e = this.modalContent.querySelector(".product");
        if (e.classList.contains("product--columns")) {
          var r = e.querySelectorAll(".product__media img");
          if (r.length) {
            let t = "(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";
            e.classList.contains("product--medium") ? (t = t.replace("715px", "605px")) : e.classList.contains("product--small") && (t = t.replace("715px", "495px")), r.forEach((e) => e.setAttribute("sizes", t));
          }
        }
      }
      enableSizeGuide(e) {
        const sizeGuideButton = this.modalContent.querySelector('.size-guide__button');
        
        // Checks for size guide button before running logic. Also hide size guide button if bundle product within quick add
        if (sizeGuideButton && !sizeGuideButton.closest('.product--bundle')) {
          // Sets size guide button to visible
          sizeGuideButton.style.setProperty('display', 'block', 'important');

          // Brings in the size guide scripts and enables them
          const targetSection = this.modalContent.closest('.quick-add-modal');
          if (targetSection) {
            const popup = e?.querySelector?.('.size-guide__popup');
            if (popup) targetSection.appendChild(popup);
          
            const popupScripts = e?.querySelectorAll?.('.size-guide__popup-script') || [];
            popupScripts.forEach(oldScript => {
              const newScript = document.createElement('script');

              [...oldScript.attributes].forEach(attr => {
                newScript.setAttribute(attr.name, attr.value);
              })

              newScript.textContent = oldScript.textContent;

              targetSection.appendChild(newScript);
            });
          }
  
          // Enables buttons open/close buttons for size guide
          const quickAddPopupContent = document.querySelector('.quick-add-modal .size-guide__popup-content')
          const quickAddSizeBtn = document.querySelector('.quick-add-modal .size-guide__button')
          const quickAddPopup = document.querySelector('.quick-add-modal .size-guide__popup')
          const quickAddCloseBtn = quickAddPopup.querySelector('.quick-add-modal .size-guide-modal__toggle')    
      
          quickAddCloseBtn.addEventListener('click', ()=> {
            quickAddPopup.classList.add('hidden')
            
            // To avoid outside clipPaths causing visual issues on the QuickView SVGs, the outer clipPaths are found and classes set to inactive. 
            // The logic below REMOVES the inactive class once the QuickView size chart is closed
            document.querySelectorAll('clipPath').forEach(cp => {
              if (!quickAddPopupContent.contains(cp)) {
                const oldId = cp.id
                if (oldId.includes('-inactive')) {
                  const newId = oldId.replace(/-inactive$/, '')
                  cp.id = newId
                }
              }
            })      
          })
      
          quickAddSizeBtn && quickAddSizeBtn.addEventListener('click', ()=> {
            quickAddPopup.classList.remove('hidden')

            // To avoid outside clipPaths causing visual issues on the QuickView SVGs, the outer clipPaths are found and classes set to inactive.
            // The logic below ADDS the inactive class once the QuickView size chart is opened
            document.querySelectorAll('clipPath').forEach(cp => {
              if (!quickAddPopupContent.contains(cp)) {
                const oldId = cp.id
                if (!oldId.includes('-inactive')) {
                  const newId = oldId + '-inactive'
                  cp.id = newId
                }
              }
            })
          })
      
          quickAddPopup.addEventListener('click', ()=> {
            quickAddPopup.classList.add('hidden')

            // To avoid outside clipPaths causing visual issues on the QuickView SVGs, the outer clipPaths are found and classes set to inactive
            // The logic below REMOVES the inactive class once the QuickView size chart is closed
            document.querySelectorAll('clipPath').forEach(cp => {
              if (!quickAddPopupContent.contains(cp)) {
                const oldId = cp.id
                if (oldId.includes('-inactive')) {
                  const newId = oldId.replace(/-inactive$/, '')
                  cp.id = newId
                }
              }
            })
          })
          
          quickAddPopupContent.addEventListener('click', (t)=>{
            t.stopPropagation()
          })
        }
      }

      enableSizeChart() {
        const sizeChart = JSON.parse(document.querySelector('.quick-add-modal .product__info-container').getAttribute('data-size-guide'))

        // Checks if size chart is present
        if (this.querySelector('[data-display="size-chart"]') === null) {
          return
        } else {
          try {
              const variants = document.querySelectorAll('.quick-add-modal .size-chart__variant-button')
              let dimensions = {}

              function getDimensions(event) {
                const selectedVariant = !!event ? event.target : variants[0]
                
                // Build dimensions object from nested array -_-
                for (let i = 0, j = 0; i < sizeChart?.rows.length; i++) {
                  if (selectedVariant.innerText.toLowerCase() === sizeChart.rows[i][0].toLowerCase()) {
                    for (let key of sizeChart.rows[0]) {
                      dimensions[key] = sizeChart.rows[i][j]
                      j++
                    }
                  }
                }

                selectedVariant.classList.add('active')
                const sizeChartDimensions = document.querySelector('.quick-add-modal .size-chart__dimension-wrapper')
                sizeChartDimensions.textContent = ''

                // Create list items and append to DOM from dimensions object
                for (let key in dimensions) {
                  if (key.toLowerCase() !== 'size') {
                    const measurement = document.createElement('li')
                    const newKey = key.trim().replace(/\s+/g, '-')

                    measurement.classList.add('size-chart__dimension')
                    measurement.classList.add(`size-chart__dimension--` + newKey.toLowerCase())
                    measurement.innerHTML = `<span>${dimensions[key]}</span>`
                    sizeChartDimensions.appendChild(measurement)
                  }
                }
              }

              getDimensions()

              for (let variant of variants) {
                variant.addEventListener('click', (event) => {
                  variants.forEach((element) => element.classList.remove('active'))
                  const selectedVariant = event.target.textContent.toLowerCase()

                  getDimensions(event)
                })
              }

              // Size Guide Tabs
              function toggleSizeGuide () {
                const tabs = document.querySelectorAll('.quick-add-modal .size-guide__tab')
                const sizeGuideContent = document.querySelectorAll('.quick-add-modal .size-guide__content')
                const dropdown = document.querySelector('.quick-add-modal .size-guide__dropdown')

                for (let tab of tabs) {    
                  tab.addEventListener('click', (event) => { 
                    tabs.forEach(element => element.classList.remove('button-tab--active'))
                    event.target.classList.add('button-tab--active')
                    dropdown.value = event.target.dataset.display

                    sizeGuideContent.forEach((element) => {
                      element.classList.add('hidden')
                      element.classList.contains(event.target.dataset.display) ? element.classList.remove('hidden') : ''
                    })
                  })
                }

                // Mobile dropdown logic
                dropdown.addEventListener('change', (event) => {
                  sizeGuideContent.forEach((element) => {
                    element.classList.add('hidden')
                    element.classList.contains(event.target.value) ? element.classList.remove('hidden') : ''

                    tabs.forEach(tab =>{  
                      tab.dataset.display === event.target.value ? tab.classList.add('button-tab--active') : tab.classList.remove('button-tab--active')
                    })
                  })
                })
              }
              toggleSizeGuide()
          } catch (error) {
            let sizeGuideContent = document.querySelector('.quick-add-modal .size-guide__content')
            if (sizeGuideContent) {
              sizeGuideContent.innerText = "There is an error in the size guide configuration."
              console.error(error)
            }
          }
        }
      }
    }
  );
